import React from 'react'
import styled from 'styled-components'
import { listIcon, deleteIcon, editIcon } from '@assets/images'

const TableBtn = ({ onClick, icon }) => {
    return (
        <Btn onClick={onClick}>
            <Icon src={icon} alt={icon.toString()} />
        </Btn>
    )
}

const Btn = styled.button`
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    background-color: transparent;
`
const Icon = styled.img`
    height: 16px;
`

export const ListBtn = ({ onClick }) => (
    <TableBtn icon={listIcon} onClick={onClick} />
)
export const DeleteBtn = ({ onClick }) => (
    <TableBtn icon={deleteIcon} onClick={onClick} />
)
export const EditBtn = ({ onClick }) => (
    <TableBtn icon={editIcon} onClick={onClick} />
)
